module.exports = __webpack_public_path__ + "static/tigersafari-0f98ab3df73b281c3cd071159aced0cf.jpg";